import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig, countries, walletsList, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the FilterBetsReportView.
 * @extends JetView
 */
export default class FilterBetsReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Get the current screen size

        // Left section of the filter form
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text', // Date range input
                            minWidth: 200,
                            name: 'DateStart',
                            id: 'DateStart',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'),
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha Creación'), // Creation date label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'richselect', // Country selection dropdown
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Country label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value; // Custom template for country options
                                    },
                                    data: countries, // Country data
                                },
                            },
                            hidden:
                                devConfig.getCountryReport() || // Conditional visibility based on config
                                !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry', // CSS class for styling
                        },
                        {
                            view: 'richselect', // State selection dropdown
                            name: 'State',
                            minWidth: 200,
                            localId: 'bonusStates:combo',
                            label: "<span class='icon-state'></span>" + _('Estado'), // State label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                // State options
                                { id: 'C', value: _('Abierto') },
                                { id: 'S', value: _('Ganó') },
                                { id: 'N', value: _('Perdió') },
                                { id: 'A', value: _('No Acción') },
                                { id: 'R', value: _('Pendiente') },
                                { id: 'W', value: _('En Espera') },
                                { id: 'J', value: _('Rechazada') },
                                { id: 'M', value: _('Rechazada por Regla') },
                                { id: 'T', value: _('Retiro Voluntario') },
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text', // Ticket ID input
                            name: 'TicketId',
                            minWidth: 200,
                            label: "<span class='icon-ticket'></span>" + _('Ticket Id'), // Ticket ID label
                            labelPosition: 'top',
                            placeholder: _('Ticket Id '), // Placeholder text
                        },
                        {
                            view: 'richselect', // Bet type selection dropdown
                            name: 'TypeBet',
                            id: 'TypeBet',
                            minWidth: 200,
                            label: _('Tipo de Apuesta'), // Bet type label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: 2, // Default value
                            options: [
                                // Bet type options
                                { id: '1', value: _('Apuestas Creadas') },
                                { id: '2', value: _('Apuestas Cerradas') },
                                { id: '3', value: _('Apuestas Pagadas') },
                                { id: '4', value: _('Apuestas Canceladas') },
                            ],
                        },
                        {
                            view: 'richselect', // Award type selection dropdown
                            name: 'TypeAwards',
                            id: 'TypeAwards',
                            minWidth: 200,
                            label: _('Tipo para Premios'), // Award type label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: 2, // Default value
                            options: [
                                // Award type options
                                { id: '1', value: _('Apuestas Cerradas') },
                                { id: '2', value: _('Apuestas Pagadas') },
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    id: 'Sort', // Sorting options section
                    cols: [
                        {
                            view: 'combo', // Sort by selection
                            name: 'Sort',
                            label: _('Ordenar por'), // Sort label
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                // Sort options
                                { id: '1', value: _('Fecha Creación') },
                                { id: '2', value: _('Usuario Id') },
                                { id: '3', value: _('Valor') },
                            ],
                            value: '1', // Default value
                        },
                        {
                            view: 'combo', // Sort direction selection
                            name: 'Dir',
                            label: _('Orden'), // Direction label
                            labelPosition: 'top',
                            minWidth: 200,
                            options: [
                                // Direction options
                                { id: '0', value: _('Ascendente') },
                                { id: '1', value: _('Descendente') },
                            ],
                            value: '0', // Default value
                        },
                        {
                            view: 'checkbox', // Summary checkbox
                            label: _('Resumido'), // Summary label
                            labelPosition: 'top',
                            name: 'IsDetails',
                            id: 'IsDetails',
                            value: 0, // Default value
                            minWidth: 200,
                        },
                    ],
                },
            ],
        };

        // Second left section for minimum and maximum prize values
        const left2 = {
            margin: 5,
            id: 'b2',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'b2',
                    cols: [
                        {
                            view: 'text', // Minimum prize value input
                            name: 'ValueMinimum',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-cash'></span>" + _('Premio Total Mínimo'), // Minimum prize label
                            labelPosition: 'top',
                            placeholder: _('Premio Total Mínimo'), // Placeholder text
                        },
                        {
                            view: 'text', // Maximum prize value input
                            name: 'ValueMaximum',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-cash'></span>" + _('Premio Total Máximo'), // Maximum prize label
                            labelPosition: 'top',
                            placeholder: _('Premio Total Máximo'), // Placeholder text
                        },
                    ],
                },
            ],
        };

        // Upper section containing the left filter form
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Including the left section
                },
            ],
        };

        // Upper section 2 containing the second left filter form
        const upper_section2 = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Including the second left section
                },
            ],
        };

        // Accordion section for additional filters
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [],
                },
            ],
        };

        // Buttons for clearing and consulting the report
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Clear label
                    width: screen == 'small' ? 0 : 100,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect); // Reset country selection
                        $$('Datepicker').setValue(''); // Reset datepicker
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Consult label
                    type: 'form',
                    width: screen == 'small' ? 0 : 100,
                    id: 'consultDesk',
                    click: () => {
                        var filterdata = this.getRoot().getValues(); // Get form values
                        if (devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add')) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country based on profile settings
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        this.app.callEvent('casinoReport:filter', [filterdata]); // Trigger filter event
                        $$('b5').collapse(); // Collapse accordion
                        $$('a5').scrollTo(100, 0); // Scroll to specific position
                    },
                },
            ],
        };

        // Accordion section 2 for mobile view
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            view: 'button', // Consult button for mobile
                            value: _('Consultar'), // Consult label
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            id: 'consultMobile',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (devConfig.getCountryReport()) {
                                    filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country based on profile settings
                                }
                                delete filterdata['CountrySelect2']; // Remove unnecessary field
                                this.app.callEvent('casinoReport:filter', [filterdata]); // Trigger filter event
                                $$('b5').collapse(); // Collapse accordion
                                $$('a5').scrollTo(100, 0); // Scroll to specific position
                            },
                        },
                        {
                            header: _('Filtros'), // Accordion header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [
                                    upper_section, // Include upper section
                                    accordion_section, // Include accordion section
                                    buttons, // Include buttons
                                ],
                            },
                        },
                    ],
                },
            ],
        };

        // Main form configuration
        return {
            view: 'form',
            id: 'myForm', // Form ID
            type: 'clean',
            rows: [accordion_section2], // Include accordion section 2
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        $$('TypeAwards').hide(); // Initially hide TypeAwards dropdown
        $$('IsDetails').attachEvent('onChange', function (newv, oldv) {
            if ($$('IsDetails').getValue() == '1') {
                $$('TypeAwards').show(); // Show TypeAwards if IsDetails is checked
                $$('TypeBet').hide(); // Hide TypeBet
            } else {
                $$('TypeBet').show(); // Show TypeBet if IsDetails is unchecked
                $$('TypeAwards').hide(); // Hide TypeAwards
            }
        });
        $$('DateStart').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal after rendering
        });
        webix.ready(function () {
            if (screen.width < 500) {
                $$('consultDesk').hide(); // Hide consultDesk button on small screens
            }
            if (screen.width >= 500) {
                $$('consultMobile').hide(); // Hide consultMobile button on larger screens
            }
        });
    }
}

// FILE DOCUMENTED
